var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-ps-placeholder" }, [
      _c("span", {
        staticClass: "ctm-ps-placeholder__icon dashicons dashicons-list-view"
      }),
      _vm._v(" "),
      _c("span", { staticClass: "ctm-ps-placeholder__text" }, [
        _vm._v("Payment Summary will show here")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }